import { RecommendationsState } from '../../../models';
import { RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsMutation } from '../recommendations.interfaces';

export class SetInfiniteScrollEnabledMutation implements RecommendationsMutation {
  mutations = {
    [RECOMMENDATIONS_MUTATIONS_KEYS.setInfiniteScrollEnabled]: (localState: RecommendationsState, infiniteScrollEnabled: boolean) => {
      localState.infiniteScrollEnabled = infiniteScrollEnabled;
    }
  };
}
